import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n';
import { BrowserRouter } from 'react-router-dom';
import CookieConsent from 'react-cookie-consent';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
    <CookieConsent
        location="bottom"
        buttonText="Accept"
        declineButtonText="Decline"
        cookieName="googleConsentCookie"
        style={{ background: '#2B373B' }}
        buttonStyle={{ color: '#4e503b', fontSize: '13px' }}
        expires={150} // Cookie expiration in days
        onAccept={() => {
          window.gtag('consent', 'update', {
            'ad_storage': 'granted',
            'ad_user_data': 'granted',
            'ad_personalization': 'granted',
            'analytics_storage': 'granted'
          });
        }}
        onDecline={() => {
          // Optional: Explicitly reinforce 'denied' state, though defaults already handle this
          window.gtag('consent', 'update', {
            'ad_storage': 'denied',
            'ad_user_data': 'denied',
            'ad_personalization': 'denied',
            'analytics_storage': 'denied'
          });
        }}
        enableDeclineButton
      >
        This website uses cookies to personalize ads and analyze traffic. By clicking "Accept," you consent to our use of cookies.
      </CookieConsent>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();